import TagResource from "./tag.resource";

const tagModule = angular
  .module("app.resources.tag", [])
  .service("Tag", TagResource);

export default tagModule;



// WEBPACK FOOTER //
// ./src/resources/tag/tag.module.js